import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { BitacoraActividadesInterface } from 'app/models/bitacora.model';

@Component({
    selector: 'actividad-reciente',
    templateUrl: 'actividad-reciente.html',
    imports:[MatTableModule, CommonModule]
})

export class ActividadRecienteComponent implements OnInit {

    @Input() ActividadReciente:  BitacoraActividadesInterface[] ;
    actividesTableColumns: string[] = [
        'descripcion',
        'fecha'
    ];

    constructor() { }
    ngOnInit() { }
}